import background from './background.mjs'
import {
  imgproxySettings,
  mobileImgproxySettings,
  resolvePaceOptionsFromSKU as resolveOptionsFromSKU,
  getSKUWithoutPrefix,
  stripMatteOrInfinitePrefix,
} from './shared.mjs'

export const frame = {
  id: 'frame',
  name: 'Frame',
  imgproxySettings,
  mobileImgproxySettings,
  options: {
    Fclear: {
      pathTemplate: 'gs://sg360/220520/Vulcans/vcf/vcf_Fclear_{nnn}.png',
    },
    clear: {
      pathTemplate: 'gs://sg360/220520/Vulcans/vcf/vcf_Fclear_{nnn}.png',
    },
    grey: {
      pathTemplate: 'gs://sg360/220520/Vulcans/vcf/vcf_Idarkgrey_{nnn}.png',
    },
    navy: {
      pathTemplate: 'gs://sg360/220520/Vulcans/vcf/vcf_Inavy_{nnn}.png',
    },
    black: {
      pathTemplate: 'gs://sg360/220520/Vulcans/vcf/vcf_Mblack_{nnn}.png',
    },
    mint: {
      pathTemplate: 'gs://sg360/220520/Vulcans/vcf/vcf_Mmint_{nnn}.png',
    },
    pink: {
      pathTemplate: 'gs://sg360/220520/Vulcans/vcf/vcf_Mpink_{nnn}.png',
    },
    red: {
      pathTemplate: 'gs://sg360/220520/Vulcans/vcf/vcf_Mred_{nnn}.png',
    },
    stone: {
      pathTemplate: 'gs://sg360/220520/Vulcans/vcf/vcf_Mstone_{nnn}.png',
    },
    white: {
      pathTemplate: 'gs://sg360/220520/Vulcans/vcf/vcf_Mwhite_{nnn}.png',
    },
    slateblue: {
      pathTemplate: 'gs://sg360/240409/slateblue/vcf_Mslateblue_{nnn}.png',
    },
    tekkerz24: {
      pathTemplate: 'gs://sg360/240709/Vu_fTekkerz-{nnn}B.png',
    },
    glacierblue: {
      pathTemplate: 'gs://sg360/260311/vcf_Iglacierblue--{nnn}.png',
    },
    neonblue: {
      pathTemplate: 'gs://sg360/260311/vcf_Ineonblue--{nnn}.png',
    },
  },
}

export const bottom = {
  id: 'bottom',
  name: 'Bottom',
  imgproxySettings,
  mobileImgproxySettings,
  options: {
    none: {
      disabled: true,
    },
    Fclear: {
      pathTemplate: 'gs://sg360/220520/Vulcans/vcb/vcb_Fclear_{nnn}.png',
    },
    clear: {
      pathTemplate: 'gs://sg360/220520/Vulcans/vcb/vcb_Fclear_{nnn}.png',
    },
    grey: {
      pathTemplate: 'gs://sg360/220520/Vulcans/vcb/vcb_Idarkgrey_{nnn}.png',
    },
    black: {
      pathTemplate: 'gs://sg360/220520/Vulcans/vcb/vcb_Iblack_{nnn}.png',
    },
    navy: {
      pathTemplate: 'gs://sg360/220520/Vulcans/vcb/vcb_Inavy_{nnn}.png',
    },
    mint: {
      pathTemplate: 'gs://sg360/220520/Vulcans/vcb/vcb_Mmint_{nnn}.png',
    },
    pink: {
      pathTemplate: 'gs://sg360/220520/Vulcans/vcb/vcb_Mpink_{nnn}.png',
    },
    red: {
      pathTemplate: 'gs://sg360/220520/Vulcans/vcb/vcb_Mred_{nnn}.png',
    },
    stone: {
      pathTemplate: 'gs://sg360/220520/Vulcans/vcb/vcb_Mstone_{nnn}.png',
    },
    white: {
      pathTemplate: 'gs://sg360/220520/Vulcans/vcb/vcb_Mwhite_{nnn}.png',
    },
    slateblue: {
      pathTemplate: 'gs://sg360/240409/slateblue/vcb_Mslateblue_{nnn}.png',
    },
    glacierblue: {
      pathTemplate: 'gs://sg360/260311/vcb_Iglacierblue--{nnn}.png',
    },
    neonblue: {
      pathTemplate: 'gs://sg360/260311/vcb_Ineonblue--{nnn}.png',
    },
  },
}

export const nose = {
  id: 'nose',
  name: 'Nose',
  imgproxySettings,
  mobileImgproxySettings,
  options: {
    none: {
      disabled: true,
    },
    Fclear: {
      pathTemplate: 'gs://sg360/220520/Vulcans/vcn/vcn_Fclear_{nnn}.png',
    },
    clear: {
      pathTemplate: 'gs://sg360/220520/Vulcans/vcn/vcn_Fclear_{nnn}.png',
    },
    grey: {
      pathTemplate: 'gs://sg360/220520/Vulcans/vcn/vcn_Idarkgrey_{nnn}.png',
    },
    black: {
      pathTemplate: 'gs://sg360/220520/Vulcans/vcn/vcn_Iblack_{nnn}.png',
    },
    navy: {
      pathTemplate: 'gs://sg360/220520/Vulcans/vcn/vcn_Inavy_{nnn}.png',
    },
    mint: {
      pathTemplate: 'gs://sg360/220520/Vulcans/vcn/vcn_Mmint_{nnn}.png',
    },
    pink: {
      pathTemplate: 'gs://sg360/220520/Vulcans/vcn/vcn_Mpink_{nnn}.png',
    },
    red: {
      pathTemplate: 'gs://sg360/220520/Vulcans/vcn/vcn_Mred_{nnn}.png',
    },
    stone: {
      pathTemplate: 'gs://sg360/220520/Vulcans/vcn/vcn_Mstone_{nnn}.png',
    },
    white: {
      pathTemplate: 'gs://sg360/220520/Vulcans/vcn/vcn_Mwhite_{nnn}.png',
    },
    slateblue: {
      pathTemplate: 'gs://sg360/240409/slateblue/vcn_Mslateblue_{nnn}.png',
    },
    glacierblue: {
      pathTemplate: 'gs://sg360/260311/vcn_Iglacierblue--{nnn}.png',
    },
    neonblue: {
      pathTemplate: 'gs://sg360/260311/vcn_Ineonblue--{nnn}.png',
    },
  },
}

export const earsocks = {
  id: 'earsocks',
  name: 'Earsocks',
  imgproxySettings,
  mobileImgproxySettings,
  options: {
    Rblack: {
      pathTemplate: 'gs://sg360/220520/Vulcans/vces/vces_Rblack_{nnn}.png',
    },
    Rblue: {
      pathTemplate: 'gs://sg360/220520/Vulcans/vces/vces_Rblue_{nnn}.png',
    },
    Rgold: {
      pathTemplate: 'gs://sg360/220520/Vulcans/vces/vces_Rgold_{nnn}.png',
    },
    Rgrey: {
      pathTemplate: 'gs://sg360/220520/Vulcans/vces/vces_Rgrey_{nnn}.png',
    },
    Rnavy: {
      pathTemplate: 'gs://sg360/220520/Vulcans/vces/vces_Rnavy_{nnn}.png',
    },
    Rstone: {
      pathTemplate: 'gs://sg360/220520/Vulcans/vces/vces_Rstone_{nnn}.png',
    },
    Rred: {
      pathTemplate: 'gs://sg360/220520/Vulcans/vces/vces_Rred_{nnn}.png',
    },
    Rmint: {
      pathTemplate: 'gs://sg360/220520/Vulcans/vces/vces_Rmint_{nnn}.png',
    },
    Rwhite: {
      pathTemplate: 'gs://sg360/220520/Vulcans/vces/vces_Rwhite_{nnn}.png',
    },
    Rslateblue: {
      pathTemplate: 'gs://sg360/240409/slateblue/vces_Rslateblue_{nnn}.png',
    },
    Rglacierblue: {
      pathTemplate: 'gs://sg360/260311/vces_Rglacierblue--{nnn}.png',
    },
    Rneonblue: {
      pathTemplate: 'gs://sg360/260311/vces_Rneonblue--{nnn}.png',
    },
  },
}

export const icons = {
  id: 'icons',
  name: 'Icons',
  imgproxySettings,
  mobileImgproxySettings,
  options: {
    Bblack: {
      pathTemplate: 'gs://sg360/220520/Vulcans/vci/vci_Bblack_{nnn}.png',
    },
    Bblue: {
      pathTemplate: 'gs://sg360/220520/Vulcans/vci/vci_Bblue_{nnn}.png',
    },
    Bgold: {
      pathTemplate: 'gs://sg360/220520/Vulcans/vci/vci_Bgold_{nnn}.png',
    },
    Bgunmetal: {
      pathTemplate: 'gs://sg360/220520/Vulcans/vci/vci_Bgunmetal_{nnn}.png',
    },
    Bpurple: {
      pathTemplate: 'gs://sg360/220520/Vulcans/vci/vci_Bpurple_{nnn}.png',
    },
    Bred: {
      pathTemplate: 'gs://sg360/220520/Vulcans/vci/vci_Bred_{nnn}.png',
    },
    Brosegold: {
      pathTemplate: 'gs://sg360/220520/Vulcans/vci/vci_Brosegold_{nnn}.png',
    },
    Bsilver: {
      pathTemplate: 'gs://sg360/220520/Vulcans/vci/vci_Bsilver_{nnn}.png',
    },
    Bwhite: {
      pathTemplate: 'gs://sg360/220520/Vulcans/vci/vci_Bwhite_{nnn}.png',
    },
  },
}

export const lenses = {
  id: 'lens',
  name: 'Lenses',
  imgproxySettings,
  mobileImgproxySettings,
  options: {
    clearTF: {
      pathTemplate: 'gs://sg360/260318/vulcans/TF_vcle_8clear_{nnn}.png',
    },
    fireTF: {
      pathTemplate: 'gs://sg360/260318/vulcans/TF_vcle_8fire_{nnn}.png',
    },
    goldTF: {
      pathTemplate: 'gs://sg360/260318/vulcans/TF_vcle_8gold_{nnn}.png',
    },
    greenTF: {
      pathTemplate: 'gs://sg360/260318/vulcans/TF_vcle_8green_{nnn}.png',
    },
    hvblueTF: {
      pathTemplate: 'gs://sg360/260318/vulcans/TF_vcle_8hvblue_{nnn}.png',
    },
    IRhvblueTF: {
      pathTemplate: 'gs://sg360/260318/vulcans/TF_vcle_8IRIShvblue_{nnn}.png',
    },
    IRsmokeTF: {
      pathTemplate: 'gs://sg360/260318/vulcans/TF_vcle_8IRISsmoke_{nnn}.png',
    },
    purpleTF: {
      pathTemplate: 'gs://sg360/260318/vulcans/TF_vcle_8purple_{nnn}.png',
    },
    silverblueTF: {
      pathTemplate: 'gs://sg360/260318/vulcans/TF_vcle_8silverblue_{nnn}.png',
    },
    smokeTF: {
      pathTemplate: 'gs://sg360/260318/vulcans/TF_vcle_8smoke_{nnn}.png',
    },
    roseTF: {
      pathTemplate: 'gs://sg360/260318/vulcans/TF_vcle_8rose_{nnn}.png',
    },
    chromeTF: {
      pathTemplate: 'gs://sg360/260318/vulcans/TF_vcle_8chrome_{nnn}.png',
    },
    clearFF: {
      pathTemplate: 'gs://sg360/260318/vulcans/BF_vcle_8clear_{nnn}.png',
    },
    fireFF: {
      pathTemplate: 'gs://sg360/260318/vulcans/BF_vcle_8fire_{nnn}.png',
    },
    goldFF: {
      pathTemplate: 'gs://sg360/260318/vulcans/BF_vcle_8gold_{nnn}.png',
    },
    greenFF: {
      pathTemplate: 'gs://sg360/260318/vulcans/BF_vcle_8green_{nnn}.png',
    },
    hvblueFF: {
      pathTemplate: 'gs://sg360/260318/vulcans/BF_vcle_8hvblue_{nnn}.png',
    },
    IRhvblueFF: {
      pathTemplate: 'gs://sg360/260318/vulcans/BF_vcle_8IRIShvblue_{nnn}.png',
    },
    IRsmokeFF: {
      pathTemplate: 'gs://sg360/260318/vulcans/BF_vcle_8IRISsmoke_{nnn}.png',
    },
    purpleFF: {
      pathTemplate: 'gs://sg360/260318/vulcans/BF_vcle_8purple_{nnn}.png',
    },
    silverblueFF: {
      pathTemplate: 'gs://sg360/260318/vulcans/BF_vcle_8silverblue_{nnn}.png',
    },
    smokeFF: {
      pathTemplate: 'gs://sg360/260318/vulcans/BF_vcle_8smoke_{nnn}.png',
    },
    roseFF: {
      pathTemplate: 'gs://sg360/260318/vulcans/BF_vcle_8rose_{nnn}.png',
    },
    chromeFF: {
      pathTemplate: 'gs://sg360/260318/vulcans/BF_vcle_8chrome_{nnn}.png',
    },
    chrome4FF: {
      pathTemplate: 'gs://sg360/260318/vulcans/BF_vcle_8chrome4_{nnn}.png',
    },
    chrome4TF: {
      pathTemplate: 'gs://sg360/260318/vulcans/TF_vcle_8chrome4_{nnn}.png',
    },
    v_IRsmokeTF: {
      pathTemplate: 'gs://sg360/260318/vcle_v_8IRsmoke--{nnn}.png',
    },
    v_IRhvblueTF: {
      pathTemplate: 'gs://sg360/260318/vcle_v_8IRhvblue--{nnn}.png',
    },
    v_silverblueTF: {
      pathTemplate: 'gs://sg360/260318/vcle_v_8silverblue--{nnn}.png',
    },
    v_IRsmokeFF: {
      pathTemplate: 'gs://sg360/260318/vcle_v_8IRsmoke--{nnn}.png',
    },
    v_IRhvblueFF: {
      pathTemplate: 'gs://sg360/260318/vcle_v_8IRhvblue--{nnn}.png',
    },
    v_silverblueFF: {
      pathTemplate: 'gs://sg360/260318/vcle_v_8silverblue--{nnn}.png',
    },
    v_IRgoldTF: {
      pathTemplate: 'gs://sg360/260903/vcle_v_8IRgold--{nnn}.png',
    },
    v_plumTF: {
      pathTemplate: 'gs://sg360/260903/vcle_v_8plum--{nnn}.png',
    },
  },
}

export const iris = {
  id: 'iris',
  name: 'Iris Mask',
  imgproxySettings,
  mobileImgproxySettings,
  isIrisMask: true,
  options: {
    none: {
      disabled: true,
    },
    IRsmokeFF: {
      pathTemplate: 'gs://sg360/260318/vulcans/BF_vcle_8IRISsmoke_{nnn}_overlay.png',
      maxOpacity: 0.7,
    },
    IRsmokeTF: {
      pathTemplate: 'gs://sg360/260318/vulcans/TF_vcle_8IRISsmoke_{nnn}_overlay.png',
      maxOpacity: 0.7,
    },
    IRhvblueFF: {
      pathTemplate: 'gs://sg360/260318/vulcans/BF_vcle_8IRIShvblue_{nnn}_overlay.png',
      maxOpacity: 1,
    },
    IRhvblueTF: {
      pathTemplate: 'gs://sg360/260318/vulcans/TF_vcle_8IRIShvblue_{nnn}_overlay.png',
      maxOpacity: 1,
    },
    v_IRsmokeTF: {
      pathTemplate: 'gs://sg360/260318/vcle_v_8IRsmoke--{nnn}_overlay.png',
      maxOpacity: 1,
    },
    v_IRhvblueTF: {
      pathTemplate: 'gs://sg360/260318/vcle_v_8IRhvblue--{nnn}_overlay.png',
      maxOpacity: 1,
    },
    v_IRgoldTF: {
      pathTemplate: 'gs://sg360/260903/vcle_v_8IRgold--{nnn}-overlay.png',
      maxOpacity: 1,
    },
  },
}

export const reflection = {
  id: 'reflections',
  isReflection: true,
  name: 'Reflections',
  imgproxySettings,
  mobileImgproxySettings,
  options: {
    none: {
      disabled: true,
    },
    r5pcTF: {
      pathTemplate: 'gs://sg360/220520/Vulcans/vcle Cloud Overlay/5/vcle_TF_Cloud Overlay 5_{nnn}.png',
    },
    r10pcTF: {
      pathTemplate: 'gs://sg360/220520/Vulcans/vcle Cloud Overlay/10/vcle_TF_Cloud Overlay 10_{nnn}.png',
    },
    r5pcFF: {
      pathTemplate: 'gs://sg360/220520/Vulcans/vcle Cloud Overlay/FF/5/vcle_FF_Cloud Overlay 5_{nnn}.png',
    },
    r10pcFF: {
      pathTemplate: 'gs://sg360/220520/Vulcans/vcle Cloud Overlay/FF/10/vcle_FF_Cloud Overlay 10_{nnn}.png',
    },
  },
}

export const engraving = {
  id: 'engraving',
  name: 'Engraving',
  imgproxySettings,
  mobileImgproxySettings,
  options: {
    eN: {
      pathTemplate: 'gs://sg360/220520/Vulcans/vclg/vclg_N_{nnn}.png',
    },
  },
}

function resolveOptions(customisedProduct) {
  const options = {
    frame: stripMatteOrInfinitePrefix(getSKUWithoutPrefix(customisedProduct.frameChoice?.sku)),
    bottom: stripMatteOrInfinitePrefix(getSKUWithoutPrefix(customisedProduct.bottomChoice?.sku) || 'none'),
    nose: stripMatteOrInfinitePrefix(getSKUWithoutPrefix(customisedProduct.noseChoice?.sku) || 'none'),
    icons: getSKUWithoutPrefix(customisedProduct.iconChoice.sku),
    engraving: 'eN',
    earsocks: getSKUWithoutPrefix(customisedProduct.earsocksChoice.sku),
    lens:
      getSKUWithoutPrefix(customisedProduct.lensChoice.skuWithoutLensTech) +
      customisedProduct.frameType.toUpperCase(),
    iris:
      getSKUWithoutPrefix(customisedProduct.lensChoice.skuWithoutLensTech) +
      customisedProduct.frameType.toUpperCase(),
    reflections: 'r5pc' + customisedProduct.frameType.toUpperCase(),
  }

  if (customisedProduct.frameType === 'tf') delete options.bottom
  if (customisedProduct.frameType === 'ff') delete options.nose

  return options
}

function resolveSecondaryOptions(customisedProduct) {
  const options = {
    bottom: stripMatteOrInfinitePrefix(getSKUWithoutPrefix(customisedProduct.bottomChoice?.sku) || 'none'),
    nose: stripMatteOrInfinitePrefix(getSKUWithoutPrefix(customisedProduct.noseChoice?.sku) || 'none'),
  }

  if (customisedProduct.frameType === 'tf') delete options.nose
  if (customisedProduct.frameType === 'ff') delete options.bottom

  return options
}

export default {
  supports360: false,
  layers: [background, frame, earsocks, bottom, nose, icons, lenses, iris, reflection],
  resolveOptions,
  resolveSecondaryOptions,
  resolveOptionsFromSKU,
}
